<template>
    <div class="meta--logo">
        <Link :href="'/'">
            <img src="/images/partfactory-icon.svg" alt="Partfactory" class="logo"><img
            src="/images/partfactory-white-icon.svg" alt="Partfactory" class="logo-alternate">
        </Link>
    </div>
</template>

<script>

import {Link} from '@inertiajs/vue3';

export default {
    name: 'MetaLogo',
    components: {
        Link
    },
};
</script>
